import { render, staticRenderFns } from "./Infraestructura.vue?vue&type=template&id=1267d98f&"
import script from "./Infraestructura.vue?vue&type=script&lang=js&"
export * from "./Infraestructura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports